<template lang="pug">
AppDropdown.vue-app-select-dropdown(direction="left")
  template(#trigger)
    a.dropdown-toggle.btn.btn-naked(data-toggle="dropdown")
      .d-flex.align-items-center
        span.m-0
          slot
            | {{ value.text }}
        i.hi.hi-caret.hi-10
  li.app-column-toggle(
    v-for="(option, index) in options"
    :key="index"
  )
    a(@click="onClick(option)")
      slot(
        name="option"
        :option="option"
      )
        p.m-0
          | {{ option.text }}
</template>
<script>
export default {
  name: 'AppSelectDropdown',
  props: {
    label: {
      type: String,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClick(selectedValue) {
      this.$emit('input', selectedValue);
    },
  },
};
</script>
